<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-8
            h1.title Dashboard IRGE &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
          .column.is-1
            label.label.is-size-6 Fecha
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='fecha'
                  :config="config"
                  class="input"
                )
          .column.is-1
            a.button.is-black(@click="descargarDashboard")
              | Descargar&nbsp
              span.icon
                i.fas.fa-file-excel
        Dashboard(:patinEB00="dataEB00" :esferasIRGE="dataEsferas" :documentacionIRGE="dataDocumentacion" 
        :dataMetaMensual="dataMetaMensual" :dataCumplimiento="dataCumplimiento" :fecha="fecha" :dataGrafica="dataGrafica")
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBar from './layout/NavBar.vue'
  import Dashboard from './componentes/Dashboard.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import moment from 'moment'
  import sca_irgeServices from '@/services/sca/irge'
  import ductosServices from '@/services/ducto'

  export default {
    name: 'HomeDashboard',
    components: { Dashboard, Loader, NavBar, flatPickr, },
    data() {
      return {
        isLoading: true,
        dataEB00: [],
        dataEsferas: [],
        dataDocumentacion: {},
        dataCumplimiento: {},
        fecha: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        fechaI: null,
        fechaF: null,
        dataMetaMensual: [],
        dataGrafica: {},
      }
    },
    watch: {
      fecha() {
        this.isLoading = true
        this.iniciarComponente()
      },
    },
    methods: {
      iniciarComponente() {
        this.fechaI = `${this.fecha.substring(0,8)}02`
        this.fechaF = moment(this.fecha).add(1, 'days').format('YYYY-MM-DD')
        this.obtenerMetaMensual()
      },

      obtenerMetaMensual() {
        const month = moment(this.fecha).format('M')
        const year = moment(this.fecha).format('Y')
        sca_irgeServices.getMetaMensual(month, year)
          .then( data => {
            this.dataMetaMensual = data.map(this.convetirDataMetaMensual)
            this.obtenerDataDocumentacion()
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('blubed', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convetirDataMetaMensual(meta) {
        return {
          ...meta,
          id: Number(meta.id),
          mes: Number(meta.mes),
          anio: Number(meta.anio),
          compania: Number(meta.compania),
          meta: Number(meta.meta),
        }
      },

      obtenerDataDocumentacion() {
        sca_irgeServices.getDataDocumentacion(this.fecha)
          .then( data => {
            this.dataDocumentacion = this.convetirDataDocumentacion(data[0])
            this.obtenerDataEsferas()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('blubed', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convetirDataDocumentacion(data) {
        return {
          ...data,
          masaProp: Number(data.masaProp),
          masaMov: Number(data.masaMov),
          masaTexMex: Number(data.masaTexMex),
          masaTotal: Number(data.masaTotal),
          atProp: Number(data.atProp),
          atMov: Number(data.atMov),
          atTexMex: Number(data.atTexMex),
          atTot: Number(data.atTot),
        }
      },

      obtenerDataEsferas() {
        const fechaIrge = moment(this.fechaF).format('DD/MM/YYYY')
        sca_irgeServices.getDataEsferas(fechaIrge)
          .then( data => {
            data.pop()
            this.dataEsferas = data.map(this.convertirDataEsferas)
            this.obtenerDataEB00()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('blubed', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convertirDataEsferas(data) {
        return {
          ...data,
          blsCor: Number(data.blsCor),
          blsNat: Number(data.blsNat),
          densidadCor: Number(data.densidadCor),
          densidadNat: Number(data.densidadNat),
          esfera: Number(data.esfera),
          nivel: Number(data.nivel),
          porcentaje: Number(data.porcentaje),
          presion: Number(data.presion),
          temp: Number(data.temp),
          volTon: Number(data.volTon),
          volTondisp: Number(data.volTondisp),
          volCorDisp: Number(data.volCorDisp),
          volNatDisp: Number(data.volNatDisp),
        }
      },

      obtenerDataEB00() {
        ductosServices.getProductoEnviado(this.fechaI, this.fechaF)
          .then( data => {
            this.dataEB00 = data.map(this.convertirDataEB00)
            this.obtenerDataCumplimiento()
          })
          .catch(e => {
            this.displayToast('blubed', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convertirDataEB00(data) {
        return {
          ...data,
          fqi_mass: Number(data.fqi_mass),
          fqi_anterior: Number(data.fqi_anterior),
          fqi_diff: Number(data.fqi_diff),
        }
      },

      obtenerDataCumplimiento() {
        const fechaInicio = this.fechaI = `${this.fecha.substring(0,8)}01`
        const dataMProp = this.dataMetaMensual.find( dm => dm.compania == 1)
        const dataMMov = this.dataMetaMensual.find( dm => dm.compania == 2)
        sca_irgeServices.getDataCumplimiento(fechaInicio, this.fecha, dataMProp.meta, dataMMov.meta)
          .then( data => {
            this.dataCumplimiento = this.convertirDataCumplimiento(data[0])
            this.obtenerDataGrafica()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('blubed', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convertirDataCumplimiento(data) {
        return {
          ...data,
          masaProp: Number(data.masaProp),
          masaMov: Number(data.masaMov),
          masaTexMex: Number(data.masaTexMex),
          masaTotal: Number(data.masaTotal),
          porcProp: Number(data.porcProp),
          porcMov: Number(data.porcMov),
          porcTexMex: Number(data.porcTexMex),
          porcPropCump: Number(data.porcPropCump),
          porcMovCump: Number(data.porcMovCump),
          porcTexMexCump: Number(data.porcTexMexCump),
        }
      },

      obtenerDataGrafica() {
        const verPropangol = moment(this.fecha).isBefore('2021-08-20')
        const fechaInicio = this.fechaI = `${this.fecha.substring(0,8)}01`
        sca_irgeServices.getDataGrafica(fechaInicio, this.fecha)
          .then( data => {
            const dataBD = data.map(this.convertirDataGrafica)
            const days = []
            const porcProp = []
            const porcMov = []
            const porcTex = []
            dataBD.map( d => {
              days.push(d.day)
              porcProp.push(d.porcProp)
              porcMov.push(d.porcMov)
              porcTex.push(d.porcTexMex)
            })
            this.dataGrafica = {
              labels: days,
              datasets: [
                {
                  label: verPropangol ? "% Propangol" : "% TexMex",
                  data: verPropangol ? porcProp : porcTex,
                  backgroundColor: "#ff4d4d",
                  borderColor: "#b83844",
                  borderWidth: 2
                },
                {
                  label: "% Movenergy",
                  data: porcMov,
                  backgroundColor: "#057d8d",
                  borderColor: "#057d8d",
                  borderWidth: 2
                }
              ],
            }
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('blubed', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convertirDataGrafica(data) {
        const long = (data.fecha.length) -2
        const day = data.fecha.substr(long,2)
        return {
          ...data,
          day: Number(day),
          masaProp: Number(data.masaProp),
          masaMov: Number(data.masaMov),
          masaTexMex: Number(data.masaTexMex),
          masaTot: Number(data.masaTot),
          porcProp: Number(data.porcProp),
          porcMov: Number(data.porcMov),
          porcTexMex: Number(data.porcTexMex),
        }
      },

      descargarDashboard() {
        const month = moment(this.fecha).format('M')
        const year = moment(this.fecha).format('Y')
        moment.locale('es-mx')
        const fechaStr = moment(this.fecha).format('DD [de] MMMM [del] YYYY')
        const diaSel = parseInt(moment(this.fecha).format('D'))
        const lastDay = parseInt(moment(this.fecha).endOf('month').format('D'))
        sca_irgeServices.createExcelDashboard(this.fecha, this.fechaI, this.fechaF, month, year, fechaStr, this.dataEsferas[0].volTon, this.dataEsferas[1].volTon, diaSel, lastDay)
          .then( data => {
            if (data.success) {
              const currentURL = window.location.hostname
              const link = `https://${currentUrl}/reportesApp/server/excel/generar_dashboard.php?nameFile=${data.file}`
              open(link, '_blank')
              setTimeout(() => {
                sca_irgeServices.borrarArchivo(data.file)
                  .then( dataD => {
                    this.displayToast(dataD.excelBorrado ? 'toasted-primary' : 'bubble', dataD.excelBorrado ? 'Archivo descargado' : 'El archivo no se pudo borrar', dataD.excelBorrado ? 'check' : 'ban', 'OK')
                    this.isLoading = false
                  })
                  .catch(err => {
                    this.displayToast('bubble', `Error:: ${err.message}`, 'ban', 'OK')
                    this.isLoading = false
                  })
              }, 4000)
            } else {
              this.displayToast('bubble', `Error::: ${data.excelBorrado}`, 'ban', 'OK')
            }
            
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('blubed', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      backPage() {
        this.$router.back()
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/dashboard/Home.vue